import {
  CalculateCartPayload,
  DeliveryType,
  DBProduct,
  ProductDbIdPayload,
} from "../";

export const getDbProductId = (product: ProductDbIdPayload): string => {
  const concatToppings =
    product.variationId ||
    (product?.toppings
      ? product?.toppings
          .map(
            (topping) =>
              `-topping-${topping.parentIndex}_${topping.toppingName}_${topping.value}`,
          )
          .join("-")
      : "");
  return `${product.id}${concatToppings}`;
};

export const mapCalculatorPayload = ({
  products,
  origin_type,
  catalogue_link,
  cart_id,
  locale,
  currency,
}: {
  products: DBProduct[];
  origin_type: string;
  catalogue_link: string;
  cart_id: string | null;
  locale: string;
  currency: string;
}): CalculateCartPayload => {
  return {
    products: products.map((product) => {
      return {
        product_id: product.id,
        units: product.quantity,
        variation_id: product.variationId,
        toppings: product.toppings
          ? product.toppings?.map((topping) => {
              return {
                name: topping.toppingName || "",
                values: [{ value: topping.value || "" }],
              };
            })
          : [],
      };
    }),
    delivery_type: DeliveryType.PickUp,
    origin_type,
    catalogue_link,
    locale,
    currency,
    ...(cart_id ? { additional_information: { cart_id } } : {}),
  };
};
